import { render, staticRenderFns } from "./selectList.vue?vue&type=template&id=005b957d&scoped=true&"
import script from "./selectList.vue?vue&type=script&lang=js&"
export * from "./selectList.vue?vue&type=script&lang=js&"
import style0 from "./selectList.vue?vue&type=style&index=0&id=005b957d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b957d",
  null
  
)

export default component.exports